module.exports = __webpack_public_path__ + "media/images/signup-d03d0d8685426bee18257d67aab2533c.png";